module.exports = __webpack_public_path__ + "static/media/Lock.9ec96a35.svg";